const entity = {
    create_failed: 'Impossibile creare {{name}}.',
    not_exists: '{{name}} non esiste.',
    not_exists_with_id: '{{name}} con ID `{{id}}` non esiste.',
    not_found: 'La risorsa non esiste.',
};
export default entity;
